import {gql} from '@apollo/client';

export const CREATE_CODE = gql`
    mutation createGetMoneyWwCode ($data: GetMoneyWwCodeInput!, $phone: String!) {
        createGetMoneyWwCode(data: $data, phone: $phone) {
            data {
                id
            }
        }
    }
`